
export default {
  name: 'Notifications',
};
